'use strict';

const { createCipheriv, createDecipheriv } = require('crypto');
const { TENCRYPT } = process.env;

const keys = env => {
	if (!env && !TENCRYPT) {
		throw new Error('You need to add the TENCRYPT configuration variable in your env.');
	}
	let [algorithm, key, sign] = (typeof env === 'string' ? env : TENCRYPT).split('|');
	[algorithm, key, sign].forEach(value => {
		if (!value) {
			throw new Error('The TENCRYPT configuration is invalid');
		}
	});
	return { algorithm, key, sign };
};

const encrypt = (value, env) => {
	let { algorithm, key, sign } = keys(env);
	try {
		let cipher = createCipheriv(algorithm, Buffer.from(key), sign);
		return Buffer.concat([cipher.update(JSON.stringify(value)), cipher.final()]).toString('hex');
	} catch (err) {
		return value;
	}
}

const decrypt = (value, env) => {
	let { algorithm, key, sign } = keys(env);
	try {
		let decipher = createDecipheriv(algorithm, Buffer.from(key), sign);
		return JSON.parse(Buffer.concat([decipher.update(Buffer.from(value, 'hex')), decipher.final()]).toString());
	} catch(err) {
		return value;
	}
}

module.exports = {
	encrypt,
	decrypt
}